import UserPermissions from '../../../../permissions/constants/userPermissions';
import { ProjectStopUnschedulingDtoModelType } from '../../models';
import getAppEnv from '../../utils/getAppEnv';
import getAppRoot from '../../utils/getAppRoot';
import { unschedulingStopMessage } from '../../../../notifications/scheduling/unscheduleStop';

const projectStopUnschedulingHandler = ({
  store, pendingSolution,
}: ProjectStopUnschedulingDtoModelType) => {
  const rootStore = getAppRoot(store);
  const showUnscheduling = rootStore.account.hasPermission(UserPermissions.ASSIGN_STOPS_TO_ROUTES);

  if (pendingSolution.assignAction.visitId != null && showUnscheduling) {
    const id = String(pendingSolution.assignAction.visitId);
    const routeName = pendingSolution.assignAction.targetRouteName;
    const { visitName } = pendingSolution.assignAction;

    getAppEnv(store).message(unschedulingStopMessage(id, visitName, routeName));
  }
};

export default projectStopUnschedulingHandler;
